import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';
import {tap} from 'rxjs/operators';
import {Observable} from '../../../../node_modules/rxjs';

@Injectable()
export class MstStaffService {
    mstStaff: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'mst_staff/list/?';
    private ListRecordByUnitId = webapi + 'mst_staff/listbyunitid/?';
    private MedStaffListRecord = webapi + 'mst_staff/MedStaffList/?';
    private DeListRecord = webapi + 'mst_staff/deactiveList/?';
    private AddRecord = webapi + 'mst_staff/create';
    private EditRecord = webapi + 'mst_staff/update';
    private GetRecord = webapi + 'mst_staff/byid/';
    private GetRecordbyEmpId = webapi + 'mst_staff/byempid/';
    private GetRecordBySubDepartment = webapi + 'mst_staff/listbysdid/';
    private GetRecordBySubDepartmentMedStaff = webapi + 'mst_staff/listbysdidMedStaff/';
    private GetRecordBySubDepartmentandunit = webapi + 'mst_staff/listbysdidunitid/';
    private GetRecordByDepartment = webapi + 'mst_staff/listbydepid/';
    private ListRecordForConcessionDepartment = webapi + 'mst_staff/liststaffforconcessionbystaff?';
    private DeleteRecord = webapi + 'mst_staff/delete/';
    private ReActiveRecord = webapi + 'mst_staff/reActive/';
    private fileupload = webapi + 'mst_staff/upload/';
    private GetRecordByUserId = webapi + 'mst_staff/byiduserid/';
    private listForAuto = webapi + 'mst_staff/listforauto/?';
    private getdrlist = webapi + 'mst_staff/getalldoctorlist/';
    private GetRecordstafftype = webapi + 'mst_staff/bystafftype/';
    private getdoctorlistbydepartmentunit = webapi + 'mst_staff/listbydepidunitad/';
    private getdoctorlistbydepartmentunitMed = webapi + 'mst_staff/listbydepidunitidMedical/';
    private getlistbydepidunitadsubdept = webapi + 'mst_staff/listbydepidunitadsubdept/';
    private getunitwiseconsessionstaff = webapi + 'mst_staff/listunitwisestaffforconcessionbystaff/';
    private usernamevalidate = webapi + 'mst_staff/usernamevalidate/';
    private GetAllDoctorByUnit = webapi + 'mst_staff/listbyunit/';
    private GetAllStaffByUnit = webapi + 'mst_staff/stafflistbyunit/';
    private GetDoctorById = webapi + 'mst_staff/doctorById/';
    private GetAllDoctorStaffTechnicianByUnit = webapi + 'mst_staff/GetAllDoctorStaffTechnicianByUnit/';
    private GetRecordByDepartmentAndUnitId = webapi + 'mst_staff/getalldoctorlistByDepartment/';
    private GetAllDoctorShareByUnit = webapi + 'mst_staff/stafflistbyunitforDoctorShare/';
    private getDoctorShareListById = webapi + 'mst_staff/DoctorSharelist/?';
    private getDoctorShareListByIdAutoC = webapi + 'mst_staff/DoctorSharelistAutoComplete';
    private GetRecordDoctorByunitId = webapi + 'mst_staff/listOfDoctorByunitid/';
    private GetAllDoctorByUnitDropDown = webapi + 'mst_staff/dropdown?';
    private GetAllDoctorShareByUnitDropDown = webapi + 'mst_staff/doctorShareDropdown?';
    private getunitwiseuser = webapi + 'mst_staff/unitwiseuser/';
    private GetAllDoctorByUnitDropdown = webapi + 'mst_staff/all_list_dropdown/';
    private getRecordByStaffListUrl = webapi + 'mst_staff/recordbystafflist/';
    private ListRecordBySpecialityId = webapi + 'mst_staff/getDoctorBySpecialityId/?';
    private GetDropDown = webapi + 'mst_staff/get_staff_by_subdepartment_list?';
    private GetDropDownBySpecialityList = webapi + 'mst_staff/get_staff_by_speciality_list?';
    private GetAllDropDownByCabinList = webapi + 'mst_staff/get_staff_by_cabin_list/?';
    private AddRecordStaffConfig = webapi + 'staff_configuration/saveConfig';
    private CheckRecordById = webapi + 'staff_configuration/checkById/';
    private GetAllStaffListByUnitNonMedNonDoc = webapi + 'mst_staff/stafflistbyunitNonMedNonDoc/';
    private GetAllEmrStaffByUnit = webapi + 'mst_staff/emrstafflistbyunit/';

    constructor(
        private http: Http
    ) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, unitId: any,sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecordByUnitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getAllRecordServiceMedStaff(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.MedStaffListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    usernameValidateService(username: any): Promise<any> {
        return this.http.get(this.usernamevalidate + username)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // Author: Mohit
    getAllStaffForConcession(departmentId: any) {
        return this.http.get(this.ListRecordForConcessionDepartment + 'departmentId=' + departmentId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAlldoctorlist(): Promise<any> {
        return this.http.get(this.getdrlist)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordForAuto(userFirstname: any, userLastname: any): Promise<any> {
        return this.http.get(this.listForAuto + 'userFirstname=' + userFirstname + '&userLastname=' + userLastname)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordBySubDepartmentService(id: any): Promise<any> {
        return this.http.get(this.GetRecordBySubDepartment + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordBySubDepartmentServiceMedStaff(id: any): Promise<any> {
        return this.http.get(this.GetRecordBySubDepartmentMedStaff + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordBySubDepartmentandunitService(id: any, unitid: any): Promise<any> {
        return this.http.get(this.GetRecordBySubDepartmentandunit + id + '/' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByDepartmentService(id: any): Promise<any> {
        return this.http.get(this.GetRecordByDepartment + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

// Rohan
    getAllRecordByDepartmentAndUnitIdService(id: any, unitId: any): Promise<any> {
        return this.http.get(this.GetRecordByDepartmentAndUnitId + id + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByDepartmentunitService(id: any, unitid: any): Promise<any> {
        return this.http.get(this.getdoctorlistbydepartmentunit + id + '/' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByDepartmentunitServiceMedicalStaff(id: any, unitid: any): Promise<any> {
        return this.http.get(this.getdoctorlistbydepartmentunitMed + id + '/' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByDepartmentunitSubDeptService(id: any, unitid: any, sdid: any): Promise<any> {
        console.log(this.getlistbydepidunitadsubdept + id + '/' + unitid + '/' + sdid);
        return this.http.get(this.getlistbydepidunitadsubdept + id + '/' + unitid + '/' + sdid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getunitwisestaff(id: any, unitid: any): Promise<any> {
        return this.http.get(this.getunitwiseconsessionstaff + id + '/' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getRecordbyEmpIdService(id: any) {
        return this.http.get(this.GetRecordbyEmpId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getRecordByStaffList(json: any) {
        return this.http.put(this.getRecordByStaffListUrl, JSON.stringify(json), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addfile(form) {
        return this.http.post(this.fileupload, form)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }

    getRecordServiceByUserId(id: any) {
        return this.http.get(this.GetRecordByUserId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllstafftypelist(id: any): Promise<any> {
        return this.http.get(this.GetRecordstafftype + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDoctorByUnit(id: any): Promise<any> {
        return this.http.get(this.GetAllDoctorByUnit + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getDoctorByStaffId(id: any): Promise<any> {
        return this.http.get(this.GetDoctorById + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDoctorByUnitForDoctorShare(id: any): Promise<any> {
        return this.http.get(this.GetAllDoctorShareByUnit + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllStaffByUnit(id: any): Promise<any> {
        return this.http.get(this.GetAllStaffByUnit + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDoctorStaffTechnicianByUnit(id: any): Promise<any> {
        return this.http.get(this.GetAllDoctorStaffTechnicianByUnit + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getDoctoreShareList(unitId: any): Promise<any> {
        return this.http.get(this.getDoctorShareListById + 'unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getDoctoreShareListAutoCom(): Promise<any> {
        return this.http.get(this.getDoctorShareListByIdAutoC)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    // get Doctor List by Unit wise
    getDoctorByUnitId(unitid: any): Promise<any> {
        return this.http.get(this.GetRecordDoctorByunitId + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDoctorByUnitDropDown(currentPage: any, size: any, unitId: any, globalFilter: any): Promise<any> {
        return this.http.get(this.GetAllDoctorByUnitDropDown + 'page=' + currentPage + '&size=' + size + '&unitId=' + unitId + '&globalFilter=' + globalFilter)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getAllDoctorShareByUnitDropDown(currentPage: any, size: any, unitId: any, globalFilter: any): Promise<any> {
        return this.http.get(this.GetAllDoctorShareByUnitDropDown  + 'page=' + currentPage + '&size=' + size + '&unitId=' + unitId + '&globalFilter=' + globalFilter)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getUnitWiseUserService(list: any, roleId: any, roleName: any): Observable<any> {
        return this.http.put(this.getunitwiseuser + roleId + '/' + roleName, JSON.stringify(list), {headers: this.headers})
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getAllDoctorByUnitdropdown(id: any): Promise<any> {
        return this.http.get(this.GetAllDoctorByUnitDropdown + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

// Rohan
    getDoctorBySpecialityId(specialityId: any, unitId: any): Promise<any> {
        return this.http.get(this.ListRecordBySpecialityId + 'specialityId=' + specialityId + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDropDown(currentPage: any, size: any, globalFilter: any, subDepartmentList: any): Promise<any> {
        console.log(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&subDepartmentList=' + subDepartmentList);
        return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&subDepartmentList=' + subDepartmentList)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDropDownBySpecialityList(currentPage: any, size: any, globalFilter: any, specialityList: any): Promise<any> {
        console.log(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&specialityList=' + specialityList);
        return this.http.get(this.GetDropDownBySpecialityList + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&specialityList=' + specialityList)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDropDownByCabinList(currentPage: any, size: any, globalFilter: any, cabinList: any): Promise<any> {
        console.log(this.getAllDropDownByCabinList + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&cabinList=' + cabinList);
        return this.http.get(this.GetAllDropDownByCabinList + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&cabinList=' + cabinList)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordStaffConfigService(model: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.AddRecordStaffConfig, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

    private logError(error: Response | any) {
        return Observable.throw(error.message || error);
    }

    checkRecordByUnitIdAndStaffId(unitId: any, staffId: any) {
        return this.http.put(this.CheckRecordById + unitId + '/' + staffId, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);

    }
    getAllStaffListByUnitNonMedNonDoc(id: any): Promise<any> {
        return this.http.get(this.GetAllStaffListByUnitNonMedNonDoc + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getAllEMRStaffByUnit(id: any): Promise<any> {
        return this.http.get(this.GetAllEmrStaffByUnit + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-staff/mst-staff.service.ts